import { render, staticRenderFns } from "./L04ShaderNoise.vue?vue&type=template&id=627f1b65&"
import script from "./L04ShaderNoise.vue?vue&type=script&lang=js&"
export * from "./L04ShaderNoise.vue?vue&type=script&lang=js&"
import style0 from "./L04ShaderNoise.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports